import React from "react";
import { Download, Film, Sparkles } from "lucide-react";

const PDF = "/AI-Agent-Platform-Proposal.pdf";

export default function Proposal() {
    return (
        <div
            data-testid="proposal-root"
            className="fixed inset-0 flex flex-col"
            style={{ background: "#140A12", fontFamily: "Manrope, sans-serif" }}
        >
            <div className="flex items-center justify-between px-5 md:px-8 py-4 border-b" style={{ borderColor: "rgba(212,175,55,0.2)" }}>
                <div className="flex items-center gap-2" style={{ color: "#FAF7F1" }}>
                    <span className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: "#7E2A6C" }}>
                        <Sparkles size={15} color="#EBD489" />
                    </span>
                    <span className="font-heading text-lg">AI Agent · Product Proposal</span>
                </div>
                <div className="flex items-center gap-3">
                    <a
                        href="/movie"
                        data-testid="proposal-movie-link"
                        className="hidden sm:inline-flex items-center gap-2 px-4 h-10 rounded-full text-sm"
                        style={{ border: "1px solid rgba(250,247,241,0.35)", color: "#FAF7F1" }}
                    >
                        <Film size={15} /> Watch the film
                    </a>
                    <a
                        href={PDF}
                        download
                        data-testid="proposal-download"
                        className="inline-flex items-center gap-2 px-5 h-10 rounded-full text-sm font-medium transition-transform hover:scale-105"
                        style={{ background: "#D4AF37", color: "#0C060B" }}
                    >
                        <Download size={16} /> Download PDF
                    </a>
                </div>
            </div>
            <iframe
                src={`${PDF}#view=FitH`}
                title="AI Agent Product Proposal"
                className="flex-1 w-full"
                style={{ border: "none", background: "#2b2b2b" }}
            />
            <noscript>
                <a href={PDF} download>Download the proposal PDF</a>
            </noscript>
        </div>
    );
}
